export const addPriceCommas = (price?: number | string) => {
  if (price) return price?.toLocaleString("hi-IN");
  else if (price === 0) return "0";
  else return "";
};

export const getPriceStatement = (price?: number | string) => {
  return `NPR. ${addPriceCommas(price)}`;
};
